/* eslint-disable default-case */
import React, { useState, useEffect, useRef, useContext } from "react";
import {
    Row,
    Col,
    Button,
    message,
    Typography,
    Input,
    Alert,
    Modal,
    Tag,
    Form,
    Tabs
} from "../../ui/ot"
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../ui/card"
import { BookCheck, CheckCircle2, BookOpen, Edit2, CalendarDays, RefreshCw, ArrowUp, ArrowDown } from "lucide-react"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table"
import { LibraryContext } from './library_context'
import dayjs from 'dayjs'
import BorrowedBooks from "./borrowed_books";
import { useNavigate } from 'react-router';
import StaffPatronModal from "./staff_patron_modal";
const BookReturn = ({
    keyPrefix = "library.backstage.book_return",
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const navigate = useNavigate();
    const [staff_form] = Form.useForm();
    const [barcode, setBarcode] = useState("")
    const [returnedBooks, setReturnedBooks] = useState([])
    const [showSuccess, setShowSuccess] = useState(false)
    const [isScanning, setIsScanning] = useState(false)
    const [item, setItem] = useState(null)
    const { branchcode, branchname } = useContext(LibraryContext);
    const [loading, setLoading] = useState(false)
    const [checkInloading, setCheckInloading] = useState(false)
    const [staffLoading, setStaffLoading] = useState(false)
    const [historyLoading, setHistoryLoading] = useState(false)
    const [todayBorrowBooks, setTodayBorrowBooks] = useState([])
    const [todayBorrowLoading, setTodayBorrowLoading] = useState(false)

    const inputRef = useRef(null)
    const [open, setOpen] = useState(false)


    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus()
        }
    }, [])

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && !isScanning && !!barcode) {
            handleManualSubmit()
        }
    }


    // Handle manual submission
    const handleManualSubmit = (e) => {
        if (!!barcode) {
            ItemController.getData({
                barcode: barcode
            }).then((response) => {
                let data = response?.data
                let dataFirst = data?.find((e) => true)
                if (!!dataFirst) {
                    setItem(dataFirst)
                    setBarcode('')
                }
                else {
                    message.error(t('item_not_found'))
                    setBarcode('')
                }
            })
        }
        // processBarcode()
    }

    const onFinish = ({ axiosMode, status, values }) => {
        if (axiosMode === "get") {
            setIsScanning(false)
        }
    };
    const onCheckInBefore = ({ axiosMode, status, values }) => {
        setCheckInloading(true)
        // setLoading(true)
        // propsOnBefore({ axiosMode, status, values })
        // setModalLoading(true)
    }
    const onCheckInFinish = ({ axiosMode, status, values }) => {
        // propsOnFinish({ axiosMode, status, values })
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('return_success'))
                let data = values?.data || []
                let firstData = data?.find((ele) => true)

                setReturnedBooks((prev) => {
                    let nowTime = new Date()
                    let temp = [
                        {
                            ...item,
                            user_department_role_data: firstData?.user_department_role_data || [],
                            returnDate: nowTime,
                            user_id: firstData?.user_id
                        },
                        ...prev
                    ]

                    return temp
                })
                setCheckInloading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    setShowSuccess(false)
                }, 3000)
            }
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                setCheckInloading(false)
                message.error(t('return_failure'))
            }
        }
    }
    const handleScanFocus = () => {
        inputRef.current.focus()
    }
    const ItemController = useCRUDController({
        // apiRoute: "/koha/item", // /library/koha/checkout
        apiRoute: "/library/koha/checkout",
        onBefore: ({ axiosMode, status }) => {
            setIsScanning(true)
        },
        onFinish: onFinish
    })
    const CheckInController = useCRUDController({
        apiRoute: "/library/koha/checkin",
        onBefore: onCheckInBefore,
        onFinish: onCheckInFinish,
    })
    const StaffPatronController = useCRUDController({
        apiRoute: "/library/organization_structure/api/staff/concatenation",
    })
    const ReturnHistoryController = useCRUDController({
        apiRoute: "/koha/checkout/history",
        onBefore: ({ axiosMode }) => {
            if (axiosMode === "get") setHistoryLoading(true)
        },
        onFinish: ({ axiosMode, status, values }) => {
            if (axiosMode !== "get") return

            setHistoryLoading(false)
            if (status === "success") {
                const todayReturns = (values || [])
                    .filter((book) => !!book?.issue_returndate)
                    .map((book) => ({
                        ...book,
                        returnDate: new Date(book.issue_returndate)
                    }))
                    .sort((a, b) => b.returnDate - a.returnDate)
                setReturnedBooks(todayReturns)
            }
        }
    })
    const TodayBorrowController = useCRUDController({
        apiRoute: "/library/koha/checkout",
    })
    const TodayBorrowHistoryController = useCRUDController({
        apiRoute: "/koha/checkout/history",
    })
    const sortByDateDesc = (records, dateKey) => {
        return records.sort((a, b) => dayjs(b?.[dateKey]).valueOf() - dayjs(a?.[dateKey]).valueOf())
    }
    const mergeTodayBorrowRecords = (activeRecords, historyRecords) => {
        const recordMap = new Map();
        [...activeRecords, ...historyRecords].forEach((record) => {
            const key = record?.issue_id || `${record?.item_itemnumber}-${record?.issue_issuedate}`;
            if (key) recordMap.set(key, record);
        })

        return sortByDateDesc(Array.from(recordMap.values()), "issue_issuedate")
    }
    const loadTodayBorrows = () => {
        const today = dayjs().format('YYYY-MM-DD')
        setTodayBorrowLoading(true)
        return Promise.all([
            TodayBorrowController.getData({
                date_issue_start: today,
                date_issue_end: today,
                cur_page: 1,
                size: 1000
            }),
            TodayBorrowHistoryController.getData({
                date_issue_start: today,
                date_issue_end: today,
                cur_page: 1,
                size: 1000
            })
        ]).then(([activeResponse, historyResponse]) => {
            setTodayBorrowBooks(mergeTodayBorrowRecords(activeResponse?.data || [], historyResponse?.data || []))
        }).catch(() => {
            message.error(t('load_today_borrows_failed'))
        }).finally(() => {
            setTodayBorrowLoading(false)
        })
    }
    const loadTodayReturns = () => {
        const today = dayjs().format('YYYY-MM-DD')
        ReturnHistoryController.getData({
            date_return_start: today,
            date_return_end: today,
            cur_page: 1,
            size: 1000
        }).catch(() => {
            setHistoryLoading(false)
        })
    }
    const loadTodayRecords = () => {
        loadTodayReturns()
        loadTodayBorrows()
    }
    useEffect(() => {
        loadTodayRecords()
        // 今日紀錄只在歸還介面首次開啟時載入；新歸還資料由既有成功回呼即時加入。
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        if (!!item && !!branchcode) {
            CheckInController.postData([
                {
                    itemnumber: item?.item_itemnumber,
                    biblionumber: item?.bib_biblionumber,
                    borrowernumber: item?.issue_borrowernumber,
                    branchcode: branchcode
                }
            ])


        }
        handleScanFocus()
    }, [item])

    return (<Row gutter={[16, 0]}>
        {returnedBooks?.length > 0 && <StaffPatronModal
            propsForm={staff_form}
            propsOpen={open}
            propsSetOpen={setOpen}
        />}
        <Col span={24}>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* Left Panel - Scanner */}
                <div className="lg:col-span-2">
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-2xl flex items-center gap-2">
                                <BookOpen className="h-6 w-6" />
                                {t('book_return')}
                            </CardTitle>
                            <CardDescription>{t('return_instruction')}</CardDescription>
                        </CardHeader>
                        <CardContent className="space-y-6">
                            <Typography.Title level={4}>
                                {t('current_branch')}：{branchname}
                            </Typography.Title>

                            {/* Barcode input section */}
                            <div className="space-y-2">
                                <div className="flex items-center justify-between">
                                    <label htmlFor="barcode-input" className="text-lg font-medium">
                                        {t('barcode_input')}：
                                    </label>
                                </div>
                                <div className="relative">
                                    <Input
                                        id="barcode-input"
                                        ref={inputRef}
                                        type="text"
                                        value={barcode}
                                        onChange={(e) => { setBarcode(e.target.value) }}
                                        onKeyDown={handleKeyDown}
                                        className="text-xl py-6 px-4 text-center"
                                        placeholder="請掃描或輸入書籍條碼..."
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="flex justify-between text-md text-muted-foreground">
                                    <span>{t('barcode_input_tip')}</span>
                                    <span>{t('barcode_input_ti2')}</span>
                                </div>
                            </div>
                            <Button
                                loading={checkInloading || isScanning}
                                // disabled={isScanning}
                                type="button"
                                onClick={() => { handleManualSubmit() }} block={true}>
                                {t('confirm_return')}
                            </Button>

                            {/* Last scanned book info */}
                            {item && (
                                <Card className="bg-muted/20 border-dashed">
                                    <CardHeader className="pb-2">
                                        <CardTitle className="text-lg">{t('recent_returns')}</CardTitle>
                                    </CardHeader>
                                    <CardContent>
                                        <div className="flex justify-between items-start">
                                            <div>
                                                <div className="text-xl font-medium">{item?.bib_title}{item?.bib_subtitle} </div>
                                                <div className="text-md text-muted-foreground mt-1">{t('isbn')}: {item?.bibitem_isbn}</div>
                                                <div className="text-md text-muted-foreground mt-1">{t('barcode')}: {item?.item_barcode}</div>
                                                <div className="text-md text-muted-foreground mt-1">{t('borrower')}: {item?.staff_name}</div>
                                                <div className="text-md text-muted-foreground mt-1">{t('note')}: {item?.issue_note}</div>
                                                {returnedBooks?.filter((ele, index) => index === 0).map((book) => (
                                                    <div className="text-md text-muted-foreground mt-1">{'單位資訊'}:
                                                        {book?.user_department_role_data && book?.user_department_role_data?.map((value) => (<>
                                                            <Tag color="geekblue">
                                                                {
                                                                    value?.role_name_language_data?.[0]?.language_culture_value ?? ''
                                                                }
                                                                {value?.user_role_department_data && <>
                                                                    －
                                                                    {value?.user_role_department_data?.map(itemItem => itemItem?.department_language_data?.[0]?.language_culture_value ?? '').join('、')}
                                                                </>}
                                                            </Tag>
                                                        </>))}
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="text-right">
                                                <div className="text-md font-medium">{t('return_time')}</div>
                                                <div className="text-md text-muted-foreground">
                                                    {new Date().toLocaleTimeString([], {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        second: "2-digit",
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>
                            )}

                            {/* Success message */}
                            {showSuccess && (
                                <Alert
                                    type="success"
                                    icon={<CheckCircle2 className="h-5 w-5 text-green-600" />}
                                    showIcon={true}
                                    message={t('return_success')}
                                    description={t('return_success_message')}
                                />
                            )}
                        </CardContent>
                    </Card>
                </div>

                {/* Right Panel - Return History */}

                <div className="lg:col-span-1">
                    <Tabs
                        defaultActiveKey="today_borrow"
                        fill={true}
                        items={[
                            {
                                key: "today_borrow",
                                tab: t('today_borrow_tab'),
                                content: <TodayBorrowRecords
                                    records={todayBorrowBooks}
                                    loading={todayBorrowLoading}
                                    onRefresh={loadTodayBorrows}
                                    keyPrefix={keyPrefix}
                                />
                            },
                            {
                                key: "today_return",
                                tab: t('today_return_tab'),
                                content: <TodayReturnRecords
                                    records={returnedBooks}
                                    loading={historyLoading}
                                    staffLoading={staffLoading}
                                    onRefresh={loadTodayReturns}
                                    onStaffClick={(book) => {
                                        setStaffLoading(true)
                                        StaffPatronController.getData({
                                            user_id: book?.user_id
                                        })
                                            .then((response) => {
                                                let data = response?.data || []
                                                staff_form.resetFields()
                                                let formValues = data
                                                staff_form.setFieldsValue({ 'recordset': formValues })
                                                setOpen(true)
                                            })
                                            .finally(() => {
                                                setStaffLoading(false)
                                            })
                                    }}
                                    keyPrefix={keyPrefix}
                                />
                            }
                        ]}
                    />
                </div>
            </div>
        </Col>
    </Row>)
}

const TodayReturnRecords = ({
    records = [],
    loading = false,
    staffLoading = false,
    onRefresh = () => { },
    onStaffClick = () => { },
    keyPrefix = "library.backstage.book_return",
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [sortDirection, setSortDirection] = useState("desc")

    const getReturnTime = (book) => {
        if (book?.returnDate) {
            return book.returnDate.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
            })
        }

        return book?.issue_returndate ? dayjs(book.issue_returndate).format("HH:mm") : "-"
    }

    const sortedRecords = [...records].sort((a, b) => {
        const timeA = dayjs(a?.returnDate || a?.issue_returndate).valueOf()
        const timeB = dayjs(b?.returnDate || b?.issue_returndate).valueOf()
        return sortDirection === "asc" ? timeA - timeB : timeB - timeA
    })

    return (
        <Card>
            <CardHeader>
                <div className="flex flex-wrap items-center justify-between gap-3">
                    <div>
                        <CardTitle className="flex items-center gap-2">
                            <BookCheck className="h-5 w-5" />
                            {t('today_return_records')}
                        </CardTitle>
                        <CardDescription>
                            {loading
                                ? t('loading_today_returns')
                                : t('returned_today', { count: records.length })}
                        </CardDescription>
                    </div>
                    <div className="flex flex-wrap items-center justify-end gap-2">
                        <Button
                            type="button"
                            variant="outline"
                            onClick={() => setSortDirection((current) => current === "asc" ? "desc" : "asc")}
                        >
                            {sortDirection === "asc"
                                ? <ArrowUp className="mr-2 h-4 w-4" />
                                : <ArrowDown className="mr-2 h-4 w-4" />}
                            {t(sortDirection === "asc" ? 'borrow_time_oldest_first' : 'borrow_time_newest_first')}
                        </Button>
                        <Button
                            type="button"
                            loading={loading}
                            disabled={loading}
                            onClick={onRefresh}
                        >
                            <RefreshCw className="mr-2 h-4 w-4" />
                            {t('refresh')}
                        </Button>
                    </div>
                </div>
            </CardHeader>
            <CardContent>
                <div className="h-[calc(100vh-20rem)] overflow-y-auto pr-2">
                    {records.length > 0 ? (
                        <Table>
                            <TableHeader>
                                <TableRow>
                                    <TableHead>{t('title')}</TableHead>
                                    <TableHead>{t('time')}</TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {sortedRecords.map((book) => (
                                    <TableRow key={`${book?.item_itemnumber}-${book?.returnDate?.getTime?.() || book?.issue_returndate || book?.issue_id}`}>
                                        <TableCell>
                                            <div className="font-medium">{book?.bib_title}{book?.bib_subtitle}</div>
                                            <div className="text-md text-muted-foreground">{t('barcode')}: {book?.item_barcode}</div>
                                            <div className="text-md text-muted-foreground mt-1">{t('borrower')}: {book?.staff_name || book?.issue_borrower_surname}
                                                {!!book?.user_id && <Button
                                                    size="small"
                                                    type="text"
                                                    loading={staffLoading}
                                                    onClick={() => onStaffClick(book)}>
                                                    <Edit2 size={12} />
                                                </Button>}
                                            </div>
                                            <div className="text-md text-muted-foreground mt-1">{t('note')}: {book?.issue_note}</div>
                                            <div className="text-md text-muted-foreground mt-1">{'單位資訊'}:
                                                {book?.user_department_role_data && book?.user_department_role_data?.map((value) => (<>
                                                    <Tag color="geekblue">
                                                        {
                                                            value?.role_name_language_data?.[0]?.language_culture_value ?? ''
                                                        }
                                                        {value?.user_role_department_data && <>
                                                            －
                                                            {value?.user_role_department_data?.map(itemItem => itemItem?.department_language_data?.[0]?.language_culture_value ?? '').join('、')}
                                                        </>}
                                                    </Tag>
                                                </>))}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            {getReturnTime(book)}
                                            <BorrowedBooksModal
                                                borrowernumber={book?.issue_borrowernumber}
                                            />
                                            <Button
                                                block={true}
                                                variant="link"
                                                className="text-blue-600 hover:text-blue-800 p-0 h-auto"
                                                onClick={() => {
                                                    window.open(`./borrow?cardnumber=${book?.issue_borrower_cardnumber}`, 'blank')
                                                }}>
                                                {t('go_to_borrow')}
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    ) : (
                        <div className="flex items-center justify-center h-40 text-muted-foreground">{t('no_return_records')}</div>
                    )}
                </div>
            </CardContent>
        </Card>
    )
}

const TodayBorrowRecords = ({
    records = [],
    loading = false,
    onRefresh = () => { },
    keyPrefix = "library.backstage.book_return",
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [sortDirection, setSortDirection] = useState("desc")

    const sortedRecords = [...records].sort((a, b) => {
        const timeA = dayjs(a?.issue_issuedate).valueOf()
        const timeB = dayjs(b?.issue_issuedate).valueOf()
        return sortDirection === "asc" ? timeA - timeB : timeB - timeA
    })

    return (
        <Card>
            <CardHeader>
                <div className="flex flex-wrap items-center justify-between gap-3">
                    <div>
                        <CardTitle className="flex items-center gap-2">
                            <CalendarDays className="h-5 w-5" />
                            {t('today_borrow_records')}
                        </CardTitle>
                        <CardDescription>
                            {loading
                                ? t('loading_today_borrows')
                                : t('borrowed_today', { count: records.length })}
                        </CardDescription>
                    </div>
                    <div className="flex flex-wrap items-center justify-end gap-2">
                        <Button
                            type="button"
                            variant="outline"
                            onClick={() => setSortDirection((current) => current === "asc" ? "desc" : "asc")}
                        >
                            {sortDirection === "asc"
                                ? <ArrowUp className="mr-2 h-4 w-4" />
                                : <ArrowDown className="mr-2 h-4 w-4" />}
                            {t(sortDirection === "asc" ? 'borrow_time_oldest_first' : 'borrow_time_newest_first')}
                        </Button>
                        <Button
                            type="button"
                            loading={loading}
                            disabled={loading}
                            onClick={onRefresh}
                        >
                            <RefreshCw className="mr-2 h-4 w-4" />
                            {t('refresh')}
                        </Button>
                    </div>
                </div>
            </CardHeader>
            <CardContent>
                <div className="h-[calc(100vh-20rem)] overflow-y-auto pr-2">
                    {records.length > 0 ? (
                        <Table>
                            <TableHeader>
                                <TableRow>
                                    <TableHead>{t('title')}</TableHead>
                                    <TableHead>{t('time')}</TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {sortedRecords.map((record) => (
                                    <TableRow key={`${record?.issue_id || record?.item_itemnumber}-${record?.issue_issuedate}`}>
                                        <TableCell>
                                            <div className="font-medium">{record?.bib_title}{record?.bib_subtitle}</div>
                                            <div className="text-md text-muted-foreground">{t('barcode')}: {record?.item_barcode}</div>
                                            <div className="text-md text-muted-foreground mt-1">{t('borrower')}: {record?.staff_name || record?.issue_borrower_surname || "-"}</div>
                                            <div className="text-md text-muted-foreground mt-1">{t('note')}: {record?.issue_note}</div>
                                        </TableCell>
                                        <TableCell>
                                            {record?.issue_issuedate ? dayjs(record.issue_issuedate).format("HH:mm") : "-"}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    ) : (
                        <div className="flex items-center justify-center h-40 text-muted-foreground">{t('no_borrow_records')}</div>
                    )}
                </div>
            </CardContent>
        </Card>
    )
}

const BorrowedBooksModal = ({
    reload = () => { },
    propsOpen = null,
    propsLoading = null,
    openButtonText = "詳細資訊",
    propsSetOpen = () => { },
    propsHandleOk = () => { },
    borrowernumber,
    // t,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const showModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(true);
        } else {
            propsSetOpen(true);
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
        reload()
    };

    const handleOk = () => {
        setLoading(true);
        closeModal();
    };




    return (
        <div>

            {propsOpen === null && <Button
                block={true}
                type="link"
                onClick={showModal}
            >
                尚未歸還紀錄
            </Button>}

            <Modal
                title={`${openButtonText}`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                // onOk={handleOk}
                // onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
                width={1600}
                contentStyle={{
                    padding: 16,
                }}
                // okText={'關閉'}
                onClose={() => { closeModal() }}
                close={true}
                closeText="關閉"
            >
                <Row>
                    <Col span={24}>
                        <BorrowedBooks
                            borrowernumber={borrowernumber}
                        />
                    </Col>
                </Row>
            </Modal>

        </div>
    )
}
export { BorrowedBooksModal }
export default BookReturn
